import { type AssetType } from "@overmap-ai/common"
import { selectAssetTypeById, selectAssetTypesByIds } from "@overmap-ai/core"

import { appStore } from "../../store"
import { FilterModifier } from "./FilterModifier"

const deserializeAssetTypeId = (filterValue: AssetType["uuid"]) => {
	const assetType = selectAssetTypeById(filterValue)(appStore.getState())

	return assetType?.uuid
}

export const AssetTypeEqualsFilterModifier = FilterModifier.create<AssetType["uuid"], AssetType["uuid"]>({
	id: "asset-type-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeAssetTypeId,
})

export const AssetTypeNotEqualsFilterModifier = FilterModifier.create<AssetType["uuid"], AssetType["uuid"]>({
	id: "asset-type-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeAssetTypeId,
})

const deserializeAssetTypeIds = (filterValue: AssetType["uuid"][]) => {
	const assetTypes = selectAssetTypesByIds(filterValue)(appStore.getState())

	const foundAssetTypeIds = assetTypes.map((assetType) => assetType.uuid)

	return foundAssetTypeIds.length > 0 ? foundAssetTypeIds : undefined
}

export const AssetTypeIncludesFilterModifier = FilterModifier.create<AssetType["uuid"], AssetType["uuid"][]>({
	id: "asset-type-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeAssetTypeIds,
})

export const AssetTypeExcludesFilterModifier = FilterModifier.create<AssetType["uuid"], AssetType["uuid"][]>({
	id: "asset-type-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeAssetTypeIds,
})
